import React, { useEffect, useState } from "react";

import moment from "moment";
import { AxiosError } from "axios";
import { useNavigate } from "react-router";
import {
  Button,
  Card,
  Col,
  message,
  Popconfirm,
  Row,
  Space,
  Table,
} from "antd";

import { BotType } from "types/bot-types";
import { PlusOutlined } from "@ant-design/icons";
import { get, remove } from "services/bot.service";

const BotList: React.FC = () => {
  const navigate = useNavigate();

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: "10%",
    },
    {
      title: "URI",
      dataIndex: "apiAi",
      key: "apiAi",
      width: "30%",
    },

    {
      title: "Waiting Time",
      key: "waitingTime",
      dataIndex: "waitingTime",
      width: "10%",
    },
    {
      title: "Auth Token",
      key: "aiAuthToken",
      dataIndex: "aiAuthToken",
      render: (aiAuthToken: string) => (
        <>{(aiAuthToken ?? "").substring(0, 4).padEnd(10, "*")}</>
      ),
      width: "10%",
    },
    {
      title: "Created At",
      key: "created",
      dataIndex: "created",
      width: "10%",
      render: (created: Date) => moment(created).format("DD/MM/yyyy HH:mm:ss"),
    },
    {
      title: "Last Modified",
      key: "lastModifiedDate",
      dataIndex: "lastModifiedDate",
      width: "10%",
      render: (lastModifiedDate: Date) =>
        moment(lastModifiedDate).format("DD/MM/yyyy HH:mm:ss"),
    },
    {
      title: "Action",
      render: (record: BotType) => (
        <Space>
          <Button onClick={() => navigate(`/bot/edit/${record.code}`)}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure to delete this bot?"
            onConfirm={() => callRemove(record.code)}
            okText="Yes"
            cancelText="No"
            placement="leftTop"
          >
            <Button danger>Remove</Button>
          </Popconfirm>
        </Space>
      ),
      width: "20%",
    },
  ];

  const [data, setData] = useState<BotType[]>([]);

  useEffect(() => {
    callGetList();
  }, []);

  const callGetList = async () => {
    const bots = await get({});
    setData(bots);
  };

  const callRemove = async (code: string) => {
    try {
      await remove(code);
      message.success("Bot is removed");
      callGetList();
    } catch (ex: AxiosError | unknown) {
      if (ex instanceof AxiosError) {
        message.error(ex.response?.data?.message);
      } else {
        message.error("Remove failed");
      }
    }
  };

  return (
    <>
      <div className="layout-content">
        <Row className="rowgap-vbox" gutter={[24, 0]}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="mb-24">
            <Card bordered={false} className="criclebox">
              <div>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => navigate("/bot/create")}
                >
                  Create
                </Button>
              </div>
              <div className="table-responsive">
                <Table
                  rowKey={"code"}
                  columns={columns}
                  dataSource={data}
                  pagination={false}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default BotList;
